import { useState } from "react";

const API_URL = process.env.REACT_APP_API_URL 

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);

  const submit = async (e) => {
    e.preventDefault();

    await fetch(`${API_URL}/auth/password-reset-request`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    setMessage("If the account exists, an email was sent.");
  };

  return (
    <form onSubmit={submit}>
      <h2>Forgot Password</h2>

      {message && <p>{message}</p>}

      <input
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <button>Send reset link</button>
    </form>
  );
}
